import { useState } from "react";
import { login } from "../services/api";
import { useNavigate } from "react-router-dom";
export default function Login({ onLogin }) {
    const [form, setForm] = useState({ username: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate(); // Initialize the hook

    const handleSubmit = async () => {
        try {
            setLoading(true);

            const res = await login(form);

            if (res?.token) {
                localStorage.setItem("token", res.token);
                onLogin();
                navigate("/admin");
            } else {
                alert("Invalid username or password");
            }
        } catch (err) {
            console.error(err);
            setError("Invalid username or password");
        } finally {
            setLoading(false); // ✅ ALWAYS runs
        }
    };

    return (
        <div className="d-flex vh-100">

            {/* LEFT SIDE */}
            <div
                className="d-flex flex-column justify-content-center align-items-center text-white"
                style={{
                    width: "50%",
                    background: "linear-gradient(135deg, #0d6efd, #6610f2)",
                }}
            >
                <h1 className="fw-bold">Liver Health Assessment</h1>
                <p className="mt-3 text-center px-5">
                    Monitor and manage liver health data efficiently.
                    Secure admin access for insights and analytics.
                </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="d-flex justify-content-center align-items-center w-50">
                <div
                    className="p-4 shadow rounded"
                    style={{ width: "350px", background: "#fff" }}
                >
                    <h3 className="text-center mb-4">Login</h3>
                    {error && <div className="text-danger mb-2">{error}</div>}
                    <input
                        className="form-control mb-3"
                        placeholder="Username"
                        onChange={(e) =>
                            setForm({ ...form, username: e.target.value })
                        }
                    />

                    <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="Password"
                        onChange={(e) =>
                            setForm({ ...form, password: e.target.value })
                        }
                    />

                    <button
                        className="btn btn-primary w-100"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? "Logging in..." : "Login"}

                    </button>

                    <div className="text-center mt-3 text-muted" style={{ fontSize: "12px" }}>
                        © 2026 Liver Assessment
                    </div>
                </div>
            </div>
        </div>
    );
}